import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["readonly"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["readonly"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  class: "normal-size",
  style: {"white-space":"pre-line"}
}

import axios from "axios";
import CoolButton from "../../../shared/CoolButton.vue";
import labels from "../../../shared/labels";
import {
    isNullOrEmpty,
    isNullOrWhitespace,
} from "../../../../../shared/utils/string";
import { computed, nextTick, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'phone-validation',
  props: {
    productId: Number,
    smsValidation: Boolean,
    smsAlreadyValid: Boolean,
    existingValidationPhone: String,
    existingValidationId: Number,
    reuseSmsValidationId: Number,
},
  emits: ["update:smsValidationId", "update:validationPhone"],
  setup(__props, { emit: __emit }) {

const props = __props;

const focusConfirmedRead = ref(false);
const hasPopup = ref(
    !isNullOrEmpty(labels.frontendProductpage.bidding.phoneValidation.popupText)
);
const locked = ref(false);
const showCodeInput = ref(false);
const finishedSmsValidation = ref(false);
const validationCode = ref("");
const validationPhone = ref(props.existingValidationPhone);
const smsValidationId = ref(props.existingValidationId);

const emit = __emit;

watch(
    () => smsValidationId.value,
    (newValue) => {
        emit("update:smsValidationId", newValue);
    },
    {
        immediate: true,
    }
);

watch(
    () => validationPhone.value,
    (newValue) => {
        emit("update:validationPhone", newValue);
    },
    {
        immediate: true,
    }
);

const isAlreadyValid = computed(() => {
    if (props.smsValidation) {
        if (smsValidationId.value != null)
            if (props.smsAlreadyValid === true) return true;
    } else {
        if (
            typeof props.existingValidationPhone == "string" &&
            props.existingValidationPhone.length > 0
        ) {
            if (validationPhone.value == props.existingValidationPhone)
                return true;
        }
    }

    return false;
});
const canClickValidate = computed(() => {
    return !isNullOrWhitespace(validationCode.value);
});
const canClickSend = computed(() => {
    return !isNullOrWhitespace(validationPhone.value);
});

async function validateCode() {
    if (isAlreadyValid.value) throw new Error("Already valid");
    if (!props.smsValidation) throw new Error("Not sms validation");
    if (finishedSmsValidation.value) throw new Error("Already finished");
    if (!showCodeInput.value) throw new Error("Not show code input");
    if (locked.value) throw new Error("Locked");
    if (smsValidationId.value == null) throw new Error("No validation id");
    if (isNullOrWhitespace(validationCode.value)) throw new Error("No code");

    locked.value = true;
    try {
        const response = await axios.get("/auctionProduct/validate-code", {
            params: {
                validationId: smsValidationId.value,
                code: validationCode.value,
            },
        });
        const result = response.data;
        if (result.success != true) {
            alert(result.message);
            return;
        }
        finishedSmsValidation.value = true;

        showCodeInput.value = true;
    } finally {
        locked.value = false;
    }
}
async function sendCode() {
    if (isAlreadyValid.value) throw new Error("Already valid");
    if (!props.smsValidation) throw new Error("Not sms validation");
    if (locked.value) throw new Error("Locked");

    locked.value = true;
    try {
        const response = await axios.get("/auctionProduct/send-code", {
            params: {
                productId: props.productId,
                phoneNumber: validationPhone.value,
            },
        });
        const result = response.data;
        if (result.success != true) {
            alert(result.message);
            return;
        }
        if (result.alreadyValid) {
            smsValidationId.value = result.validationId;
            finishedSmsValidation.value = true;
            return;
        }

        if (!result.sent) {
            alert("Error. Sms not sent.");
            return;
        }

        smsValidationId.value = result.validationId;
        showCodeInput.value = true;
    } finally {
        locked.value = false;
    }
}

const popupContainer = ref<HTMLSpanElement>();
const field = ref<HTMLInputElement>();

// Safari-specific fix: Prevent endless loop of blur and focus.
const dialogOpen = ref(false);

function onFieldFocus(e: Event) {
    if (dialogOpen.value) {
        // console.debug("focus field (cancelled)");
        return;
    }
    // console.debug("focus field");
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    if (!focusConfirmedRead.value) {
        if (hasPopup.value && popupContainer.value != null) {
            dialogOpen.value = true;
            const popup = window.$(popupContainer.value);
            popup.data("customization", function (configuration: any) {
                configuration.onHide = function (hash: any) {
                    // console.debug("on hide");
                    dialogOpen.value = false;
                    return window.$.jqm.params.onHide(hash);
                };
                return configuration;
            });
            popup.data("onceOk", [
                function () {
                    // console.debug("onceOk");
                    focusConfirmedRead.value = true;
                    nextTick(function () {
                        field.value?.focus();
                    });
                },
            ]);
            popup.click();

            return;
        }
    }
}
function onFieldBlur() {
    if (dialogOpen.value) {
        // console.debug("blur field (cancelled)");
        return;
    }
    // console.debug("blur field");
    focusConfirmedRead.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.reuseSmsValidationId != null)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "hidden",
          name: "reuseSmsValidationId",
          value: __props.reuseSmsValidationId
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createVNode(_Transition, {
      "enter-active-class": _ctx.$style['enter'],
      "leave-active-class": _ctx.$style['leave'],
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (finishedSmsValidation.value)
          ? (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['phone-validation', _ctx.$style['view-3']]),
              key: "finished-validation"
            }, [
              _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.bidding.phoneValidation.validated) + " ", 1 /* TEXT */),
              _createElementVNode("input", {
                type: "hidden",
                name: "validationPhone",
                value: validationPhone.value
              }, null, 8 /* PROPS */, _hoisted_2),
              _createElementVNode("input", {
                type: "hidden",
                name: "smsValidationId",
                value: smsValidationId.value
              }, null, 8 /* PROPS */, _hoisted_3)
            ], 2 /* CLASS */))
          : (showCodeInput.value)
            ? (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['phone-validation', _ctx.$style['view-2']]),
                key: "enter-code"
              }, [
                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.bidding.phoneValidation
                        .smsCodeHeader), 1 /* TEXT */),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((validationCode).value = $event)),
                  class: _normalizeClass(_ctx.$style['code-input']),
                  readonly: locked.value
                }, null, 10 /* CLASS, PROPS */, _hoisted_4), [
                  [_vModelText, validationCode.value]
                ]),
                _createVNode(CoolButton, {
                  inline: "",
                  size: "small",
                  style: {}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (validateCode())),
                      disabled: locked.value || !canClickValidate.value
                    }, _toDisplayString(_unref(labels).frontendProductpage.bidding.phoneValidation
                                .validateCodeBtn), 9 /* TEXT, PROPS */, _hoisted_5)
                  ], undefined, true),
                  _: 1 /* STABLE */
                })
              ], 2 /* CLASS */))
            : (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['phone-validation', _ctx.$style['view-1']]),
                style: _normalizeStyle({ display: isAlreadyValid.value ? 'none' : '' }),
                key: "phone-validation"
              }, [
                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.bidding.phoneValidation.header), 1 /* TEXT */),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "validationPhone",
                  class: _normalizeClass(_ctx.$style['phone-input']),
                  readonly: locked.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((validationPhone).value = $event)),
                  ref_key: "field",
                  ref: field,
                  onFocus: _cache[3] || (_cache[3] = ($event: any) => (onFieldFocus($event))),
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (onFieldBlur()))
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_6), [
                  [_vModelText, validationPhone.value]
                ]),
                (__props.smsValidation)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(CoolButton, {
                        inline: "",
                        size: "small",
                        style: {}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (sendCode())),
                            disabled: locked.value || !canClickSend.value
                          }, _toDisplayString(_unref(labels).frontendProductpage.bidding
                                    .phoneValidation.sendCodeBtn), 9 /* TEXT, PROPS */, _hoisted_7)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      (__props.smsValidation)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "hidden",
                            name: "smsValidationId",
                            value: smsValidationId.value
                          }, null, 8 /* PROPS */, _hoisted_8))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (hasPopup.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(
                        _ctx.$style['tooltip-action'] +
                        ' tooltip-hint popup-text gray small'
                    ),
                      ref_key: "popupContainer",
                      ref: popupContainer
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(labels).frontendProductpage.bidding.phoneValidation
                            .popupText), 1 /* TEXT */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 6 /* CLASS, STYLE */))
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["enter-active-class", "leave-active-class"])
  ]))
}
}

})